import type { IElementID } from '@shared/models/project.model';

let pendingRestoreElementId: IElementID | undefined;

export const setPendingRestoreElementId = (id: IElementID): void => {
  pendingRestoreElementId = id;
};

export const consumePendingRestoreElementId = (): IElementID | undefined => {
  const id = pendingRestoreElementId;
  pendingRestoreElementId = undefined;
  return id;
};
